module.exports = __webpack_public_path__ + "img/sq1.c5658b69.png";